import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { useAppConfigContext } from '@/context/AppConfig';
import { request } from '@/utils/requestHelpers';

const baseQueryKey = 'smartcar';

export const useDisconnectFromSmartcar = (
  smartcarId: string | null | undefined
) => {
  const { logError } = useAppConfigContext();
  const queryClient = useQueryClient();

  const disconnectVehicleMutation = useMutation({
    mutationFn: () => {
      return disconnectVehicle(smartcarId);
    },
    onSuccess: (response) => {
      if (response.success) {
        enqueueSnackbar('Successful disconnected vehicle', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        queryClient.invalidateQueries({
          queryKey: [`${baseQueryKey}-${smartcarId}`],
        });
      }
    },
    onError: (error) => {
      enqueueSnackbar('Failed to disconnect vehicle error', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      logError('Failed to disconnect vehicle error', error as Error);
    },
  });

  return {
    disconnectVehicleMutation,
  };
};

const disconnectVehicle = async (smartcarId: string | null | undefined) => {
  if (!smartcarId) return new Error('No smart car id');

  return await request(`/api/v5/connected_vehicles/${smartcarId}`, {
    method: 'DELETE',
  });
};
